import React, {useEffect, useState} from 'react'
import {connect} from "react-redux";
import {CircularProgress} from "@mui/material";
import {useRoute} from "react-router5";

import Popup from "../../../components/Popup";
import SelectTemplateView from "../../Contracts/SelectTemplateView";
import {httpClient} from "../../../funcs";
import notifyUser, {notifyAboutError} from "../../../methods/notifyUser";
import ApiKeyField from "../../../components/ApiKeyField";

type Props = {
    close: Function,
    $store: any,
    $commitToStore: Function,
    currentTemplate?: any,
}

let RealtyIntegrationV2Popup: any = function RealtyIntegrationV2Popup(props: Props) {
    const $router = useRoute()
    const [selectedTemplate, setSelectedTemplate] = useState<any>(null)
    const [templates, setTemplates] = useState<any[]>([])
    const [loading, setLoading] = useState(false)
    const [importSuccess, setImportSuccess] = useState(false)
    const [importedCount, setImportedCount] = useState(0)
    const [apiKeyError, setApiKeyError] = useState(false)
    const realtyConfig = props.$store.userSession?.realty_integration
    const isOldIntegrationEnabled = realtyConfig && (realtyConfig.integration_type === 1 || realtyConfig.integration_type === 2)

    useEffect(() => {
        loadTemplates()
        if (props.currentTemplate) {
            setSelectedTemplate(props.currentTemplate)
        }
    }, [props.currentTemplate])

    async function loadTemplates() {
        try {
            const {data} = await httpClient.get(`/templates`)
            setTemplates(data)
        } catch (error) {
            notifyAboutError(props, error)
        }
    }

    function goToTemplate() {
        if (selectedTemplate?.id) {
            $router.router.navigate(
                "new-contract",
                {act: "new", templateId: selectedTemplate.id},
                {reload: true}
            )
            props.close()
        }
    }

    function resetImport() {
        setImportSuccess(false)
        setImportedCount(0)
        setApiKeyError(false)
    }

    function onCopyApiKey() {
        notifyUser(props, "API ключ скопирован в буфер обмена");
    }

    function apiKey() {
        return `${props.$store.userSession.realty_api_key}`
    }

    async function fetchRealtyData() {
        if (!props.$store.userSession?.realty_api_key) {
            notifyUser(props, "Ошибка", "API ключ RealtyCalendar не найден")
            return
        }

        if (!selectedTemplate?.id) {
            notifyUser(props, "Ошибка", "Выберите шаблон для импорта")
            return
        }

        setLoading(true)
        try {
            const response = await httpClient.post('/template/import-realty-objects', {
                template_id: selectedTemplate.id,
                realty_api_key: props.$store.userSession.realty_api_key
            })

            const result = response.data

            if (result.objects_count === 0) {
                notifyUser(props, "Информация", "Объекты не найдены в RealtyCalendar")
            } else {
                setImportedCount(result.objects_count)
                setImportSuccess(true)
                await httpClient.get('/user/self').then(({ data }) => {
                    props.$commitToStore({
                        userSession: data
                    })
                })
            }
        } catch (error: any) {
            console.error('Error importing realty objects:', error)
            if (error.response?.status === 401) {
                setApiKeyError(true)
            } else if (error.response?.data?.includes('Неверный формат API ключа')) {
                notifyUser(props, "Ошибка", "Неверный формат API ключа RealtyCalendar")
            } else {
                notifyAboutError(props, error)
            }
        } finally {
            setLoading(false)
        }
    }


    return (
        <Popup
            maxWidth="650px"
            onClose={() => props.close()}
        >
            <div>
                <div className="commonLabel" style={{marginBottom: "15px"}}>
                    Новая интеграция с RealtyCalendar 2.0
                </div>
                <div className="commonSubtitle" style={{marginBottom: "16px"}}>
                    Работайте с договорами прямо из личного кабинета RealtyCalendar: создавайте их и отслеживайте статусы подписания там же. В договор передаются ключевые данные брони:
                </div>
                <ul style={{margin: "0 0 16px 18px", padding: 0, color: "#495057", fontSize: "14px", lineHeight: "1.5"}}>
                    <li>Адрес объекта</li>
                    <li>Дата заселения и выселения</li>
                    <li>Депозит</li>
                </ul>

                <div style={{
                    background: "#f8f9fa",
                    border: "1px solid #e9ecef",
                    borderRadius: "8px",
                    padding: "16px",
                    marginBottom: "20px",
                    fontSize: "14px",
                    lineHeight: "1.5",
                    color: "#495057"
                }}>
                    <div style={{fontWeight: 600, marginBottom: "10px"}}>Как подключить (3 шага):</div>
                    <ol style={{margin: "0 0 12px 18px", padding: 0}}>
                        <li style={{marginBottom: "6px"}}>Скопируйте ваш API ключ ниже.</li>
                        <li style={{marginBottom: "6px"}}>
                            Перейдите в личный кабинет RealtyCalendar и включите интеграцию по инструкции:{" "}
                            <a
                                href="https://realtycalendar.helpdeskeddy.com/ru/knowledge_base/article/352/category/25"
                                target="_blank"
                                rel="noreferrer"
                                style={{textDecoration: "underline", color: "#1e40af"}}
                            >
                                открыть инструкцию
                            </a>
                        </li>
                        <li style={{marginBottom: "0px"}}>Выберите шаблон и активируйте синхронизацию.</li>
                    </ol>
                </div>

                <div style={{marginBottom: "20px"}}>
                    <ApiKeyField
                        title="Ваш API ключ для RealtyCalendar:"
                        value={apiKey()}
                        onCopy={onCopyApiKey}
                    />
                </div>

                {isOldIntegrationEnabled && (
                    <div style={{
                        background: "#fff3cd",
                        border: "1px solid #ffeaa7",
                        borderRadius: "6px",
                        padding: "12px",
                        fontSize: "13px",
                        color: "#856404",
                        marginBottom: "20px"
                    }}>
                        ⚠️ При активации новой интеграции старая интеграция с RealtyCalendar будет автоматически отключена.
                    </div>
                )}

                <div style={{
                    background: "#f0f8ff",
                    border: "1px solid #b3d9ff",
                    borderRadius: "8px",
                    padding: "20px",
                    marginBottom: "20px"
                }}>
                    <div style={{fontWeight: "600", marginBottom: "15px", color: "#1e40af", fontSize: "16px"}}>
                        🔄 Импорт объектов и какие данные подтянутся
                    </div>
                    <div style={{display: "flex", flexDirection: "column", gap: "15px"}}>
                        <div style={{fontSize: "14px", color: "#495057", lineHeight: "1.5"}}>
                            Вы можете разово подтянуть все объекты из RealtyCalendar в выбранный шаблон. Это добавит поле «Описание и адрес квартиры» с вашим списком объектов и обязательными полями интеграции.
                        </div>
                        <div style={{fontSize: "14px", lineHeight: "1.6", color: "#495057"}}>
                            Для каждого объекта создается запись с полями:
                        </div>
                        <ul style={{margin: "0 0 12px 18px", padding: 0, color: "#495057", fontSize: "14px", lineHeight: "1.5"}}>
                            <li>Адрес объекта</li>
                            <li>Дата заселения и выселения</li>
                            <li>Депозит</li>
                            <li>Перечень имущества (пустое для заполнения)</li>
                        </ul>
                        <div style={{fontSize: "14px", lineHeight: "1.6", color: "#495057"}}>
                            Дополнительно в шаблон будут добавлены поля интеграции:
                        </div>
                        <ul style={{margin: "0 0 12px 18px", padding: 0, fontSize: "13px", color: "#495057", lineHeight: "1.5"}}>
                            <li>Дата заселения, Дата выселения</li>
                            <li>Цена в сутки, Полная стоимость</li>
                            <li>Обеспечительный платеж, Количество суток</li>
                        </ul>
                        <div style={{
                            background: "#fff3cd",
                            border: "1px solid #ffeaa7",
                            borderRadius: "6px",
                            padding: "12px",
                            fontSize: "13px",
                            color: "#856404"
                        }}>
                            ⚠️ <strong>Важно:</strong> Существующее поле "Описание и адрес квартиры" будет заменено новым с импортированными объектами
                        </div>
                    </div>
                </div>

                <div className="commonLabel" style={{marginBottom: "10px"}}>
                    Выберите шаблон:
                </div>
                <SelectTemplateView
                    selectedTemplate={selectedTemplate}
                    didSelectTemplate={(template: any) => setSelectedTemplate(template)}
                />

                {!importSuccess && !apiKeyError ? (
                    <div style={{marginTop: "20px", display: "flex", flexDirection: "column", gap: "10px"}}>
                        <button
                            className="new withTitle _wa"
                            onClick={fetchRealtyData}
                            disabled={!selectedTemplate?.id || loading}
                        >
                            <div className="buttonsContainer">
                                {loading && <CircularProgress size={"20px"} sx={{color: "#1FA3EE"}} />}
                                <span>Импортировать объекты из RealtyCalendar</span>
                            </div>
                        </button>
                    </div>
                ) : apiKeyError ? (
                    <div style={{marginTop: "20px", display: "flex", flexDirection: "column", gap: "15px"}}>
                        <div style={{
                            background: "#f8d7da",
                            border: "1px solid #f5c6cb",
                            borderRadius: "8px",
                            padding: "15px",
                            textAlign: "center"
                        }}>
                            <div style={{fontSize: "16px", fontWeight: "600", color: "#721c24", marginBottom: "8px"}}>
                                🔑 API ключ не настроен
                            </div>
                            <div style={{fontSize: "14px", color: "#721c24", marginBottom: "10px"}}>
                                API ключ RealtyCalendar не настроен или неверный
                            </div>
                            <div style={{fontSize: "13px", color: "#721c24"}}>
                                Перейдите в личный кабинет RealtyCalendar и настройте интеграцию с OkiDoki
                            </div>
                        </div>
                        
                        <button
                            className="new withTitle"
                            onClick={resetImport}
                        >
                            <span>Попробовать снова</span>
                        </button>
                    </div>
                ) : (
                    <div style={{marginTop: "20px", display: "flex", flexDirection: "column", gap: "15px"}}>
                        <div style={{
                            background: "#d4edda",
                            border: "1px solid #c3e6cb",
                            borderRadius: "8px",
                            padding: "15px",
                            textAlign: "center"
                        }}>
                            <div style={{fontSize: "16px", fontWeight: "600", color: "#155724", marginBottom: "5px"}}>
                                ✅ Импорт завершен успешно!
                            </div>
                            <div style={{fontSize: "14px", color: "#155724"}}>
                                Импортировано {importedCount} объектов в шаблон "{selectedTemplate?.title}"
                            </div>
                        </div>
                        
                        <div style={{display: "flex", gap: "10px"}}>
                            <button
                                className="new withTitle _wa"
                                onClick={goToTemplate}
                                style={{flex: 1}}
                            >
                                <span>Перейти к шаблону</span>
                            </button>
                            <button
                                className="new withTitle"
                                onClick={resetImport}
                                style={{flex: 1}}
                            >
                                <span>Импортировать еще</span>
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </Popup>
    )
}

RealtyIntegrationV2Popup = connect(
    (store) => ({ $store: store }),
    (dispatch) => ({
        $commitToStore: (data: any) => dispatch({ ...data, type: 'S' })
    })
)(RealtyIntegrationV2Popup)

export default RealtyIntegrationV2Popup
